module.exports = __webpack_public_path__ + "img/QuebrarAratBdgd.2f38ac56.png";